import { render, staticRenderFns } from "./teach-guide.vue?vue&type=template&id=2325687e&scoped=true&lang=pug&"
import script from "./teach-guide.vue?vue&type=script&lang=js&"
export * from "./teach-guide.vue?vue&type=script&lang=js&"
import style0 from "./teach-guide.vue?vue&type=style&index=0&id=2325687e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325687e",
  null
  
)

export default component.exports